<template>
  <div>
    <b-row>
      <b-col>
        <div class="attachments">
          <b-card v-for="(mail, index) in mails" :key="`mail-${mail.key}`">
            <h3>{{ mail.title }}</h3>

            <p class="mt-4 mb-1"><strong>Huidige bijlagen</strong></p>
            <b-row>
              <b-col>
                <template v-if="mail.attachments.length">
                  <div
                    v-for="attachment in mail.attachments"
                    :key="`attachment-${attachment.id}`"
                    class="attachment"
                  >
                    {{ attachment.original_filename }}
                    <span class="filesize">
                      {{
                        prettyBytes(attachment.size, {
                          maximumFractionDigits: 1,
                          locale: 'nl',
                        })
                      }}
                    </span>

                    <span class="delete-attachment">
                      <i class="far fa-trash-alt" />
                    </span>
                  </div>
                </template>
                <template v-else>
                  <i>Er zijn nog geen bijlagen toegevoegd aan deze mail.</i>
                </template>
              </b-col>
            </b-row>

            <p class="mt-4 mb-1"><strong>Nieuwe bijlagen toevoegen</strong></p>
            <b-form-group class="mb-0">
              <b-form-file
                v-model="mail.newAttachments"
                placeholder="Sleep bestanden naar deze ruimte of upload via de knop"
                browse-text="Upload bestanden"
                drop-placeholder="Sleep bestanden naar deze ruimte om up te loaden"
                multiple
                @input="setFilenames($event, index)"
              />
            </b-form-group>

            <b-row v-if="mail.filenames.length" class="mt-3">
              <b-col>
                <div
                  v-for="(file, index) in mail.filenames"
                  :key="`file-${index}`"
                  class="file-to-upload"
                >
                  <Input class="input-filename" v-model="file.name" />
                  <span class="filesize">
                    {{
                      prettyBytes(file.size, {
                        maximumFractionDigits: 1,
                        locale: 'nl',
                      })
                    }}
                  </span>
                </div>
              </b-col>
            </b-row>

            <b-row class="text-right mt-3" v-if="mail.newAttachments.length">
              <b-col>
                <button-spinner
                  :loading="loading[mail.key]"
                  variant="primary"
                  @click="uploadAttachments(index, mail.key)"
                >
                  Opslaan
                </button-spinner>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import prettyBytes from 'pretty-bytes';
import _ from 'lodash';

export default {
  data() {
    return {
      errors: [],

      loading: [],

      mails: [
        {
          title: 'Creditfactuur',
          key: 'credit',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Factuur',
          key: 'invoice',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Order bevestiging',
          key: 'order-confirmation',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Order in behandeling',
          key: 'order-processing',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Order verzonden',
          key: 'order-sent',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Order geannuleerd',
          key: 'order-cancelled',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Proefmonster in behandeling',
          key: 'sample-order-processing',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
        {
          title: 'Proefmonster verzonden',
          key: 'sample-order-sent',
          attachments: [],
          newAttachments: [],
          filenames: [],
        },
      ],
    };
  },

  methods: {
    prettyBytes,

    setLoadingStates() {
      this.mails.forEach((mail) => {
        this.loading[mail.key] = false;
      });
    },

    setFilenames(event, index) {
      this.mails[index].filenames = [];

      event.forEach((file) => {
        this.mails[index].filenames.push({
          name: file.name,
          size: file.size,
        });
      });
    },

    getAttachments() {
      this.$http.get(`attachments`).then(({ data }) => {
        data.data.forEach((attachment) => {
          const targetMail = this.mails.find(
            (mail) => mail.key === attachment.mail,
          );

          if (targetMail) {
            targetMail.attachments.push(attachment);
          }
        });
      });
    },

    uploadAttachments(index, key) {
      this.loading[key] = true;

      const data = new FormData();
      const options = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      _.each(this.mails[index].newAttachments, (attachment) => {
        data.append('new_attachments[]', attachment);
      });

      _.each(this.mails[index].filenames, (filename) => {
        data.append(`new_filenames[]`, filename.name);
      });

      data.append(
        'payload',
        JSON.stringify({
          key: key,
        }),
      );

      this.$http
        .post('attachments', data, options)
        .then(({ data }) => {
          this.mails[index].attachments = [
            ...this.mails[index].attachments,
            ...data.data,
          ];

          this.mails[index].newAttachments = [];
          this.mails[index].filenames = [];
        })
        .catch(() => {})
        .finally(() => {
          this.loading[key] = true;
        });
    },
  },

  mounted() {
    this.setLoadingStates();
    this.getAttachments();
  },
};
</script>
